<app-header [hideCompanyInfo]="true"></app-header>

<div class="panel">

  <img [src]="getLogoPath()" alt="Not found" width="250">
  <h1>404</h1>
  <h3>Sorry, page not found.</h3>
  <button mat-raised-button color="primary" (click)="goBack()">Go back</button>

</div>
